export default __webpack_public_path__ + "static/media/remove-tag.17825c74.svg";